export default __webpack_public_path__ + "static/media/intro-cat.16d7ac78.png";